import { render, staticRenderFns } from "./BgmView.vue?vue&type=template&id=9b507d2c&scoped=true"
import script from "./BgmView.vue?vue&type=script&lang=js"
export * from "./BgmView.vue?vue&type=script&lang=js"
import style0 from "./BgmView.vue?vue&type=style&index=0&id=9b507d2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b507d2c",
  null
  
)

export default component.exports